import clsx from 'clsx';
import { LogOutIcon } from 'lucide-react';

import useAuth from '../../hooks/useAuth';
import MenuItem from './components/MenuItem';
import { ReactComponent as FAQIcon } from './components/icons/faq.svg';
import { ReactComponent as HomeIcon } from './components/icons/home.svg';
import { ReactComponent as ModuleIcon } from './components/icons/modules.svg';
import { ReactComponent as CalenarIcon } from './components/icons/calendar.svg';

export function LeftSidebar({
  isMobileMenuOpen,
  collapseSidebar
}) {
  const { signOut } = useAuth();

  const handleLogout = () => {
    signOut();
  };

  return (
    <aside
      className={clsx(
        'fixed top-0 left-0 z-40 h-screen pt-20 transition-transform -translate-x-full bg-primary  md:translate-x-0 dark:bg-gray-800',
        {
          'translate-x-0': isMobileMenuOpen,
          '-translate-x-full': !isMobileMenuOpen,
          'w-64': !collapseSidebar,
          // 'w-16': collapseSidebar,
          hidden: collapseSidebar
        }
      )}
      aria-label='Sidenav'
      id='drawer-navigation'
    >
      <div className='overflow-y-auto py-5 px-3 h-full bg-primary dark:bg-gray-800'>
        <ul className='space-y-2'>
          <li>
            <MenuItem
              to='/dashboard'
              collapseSidebar={collapseSidebar}
              uniqueId='home-icon-menu-sidebar'
              name='Courses'
              icon={
                <HomeIcon className='w-6 h-6 text-white group-hover:text-primary' />
              }
            />
          </li>
          <li>
            <MenuItem
              to='/modules'
              collapseSidebar={collapseSidebar}
              uniqueId='module-icon-left-sidebar'
              name='Modules'
              icon={
                <ModuleIcon className='w-6 h-6 text-white group-hover:text-primary' />
              }
            />
          </li>
        </ul>
        <ul className='pt-5 mt-5 space-y-2 border-t border-gray-200 dark:border-gray-700'>
          <li>
            <MenuItem
              to='/calendar'
              collapseSidebar={collapseSidebar}
              uniqueId='calendar-icon-menu-sidebar'
              name='Calendar'
              icon={
                <CalenarIcon className='w-6 h-6 text-white group-hover:text-primary' />
              }
            />
          </li>
          <li>
            <MenuItem
              to='/page/faq-and-help'
              collapseSidebar={collapseSidebar}
              uniqueId='help-and-faq-icon-menu-sidebar'
              name='Help & FAQ'
              icon={
                <FAQIcon className='w-6 h-6 text-white group-hover:text-primary' />
              }
            />
          </li>
        </ul>
      </div>
      <div
        className={clsx(
          'hidden absolute bottom-5 left-0 px-3 w-full lg:flex bg-primary dark:bg-gray-800 z-20',
          {
            'flex-col': collapseSidebar,
            'space-x-4': !collapseSidebar
          }
        )}
      >
        <div
          role='button'
          tabIndex={0}
          onClick={handleLogout}
          className='group inline-flex justify-center p-2 text-gray-500 rounded cursor-pointer dark:text-gray-400 dark:hover:text-white hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-600'
        >
          <LogOutIcon className='w-6 h-6 text-white group-hover:text-primary' />
          {!collapseSidebar && (
            <span className='ml-3 text-white group-hover:text-primary'>
              Log out
            </span>
          )}
        </div>
        <div
          id='tooltip-settings'
          role='tooltip'
          className='inline-block absolute  z-10 py-2 px-3 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm opacity-0 transition-opacity duration-300 tooltip'
          style={{
            position: 'absolute',
            inset: 'auto auto 0px 0px',
            margin: '0px',
            transform: 'translate(71px, -64px)'
          }}
          data-popper-placement='top'
        >
          Settings page
          <div
            className='tooltip-arrow'
            data-popper-arrow
          />
        </div>
      </div>
    </aside>
  );
}
